var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vs-tooltip", class: _vm.classes }, [
    _vm.label
      ? _c("label", { staticClass: "vs-tooltip__label" }, [
          _vm._v(_vm._s(_vm.label) + "  ")
        ])
      : _vm._e(),
    _c("div", { ref: "reference", staticClass: "vs-tooltip__icon" }, [
      !_vm.type
        ? _c(
            "svg",
            { staticClass: "h-1 w-1", attrs: { viewBox: "0 0 24 24" } },
            [
              _c("path", {
                staticClass: "fill-current",
                attrs: {
                  d:
                    "M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z"
                }
              })
            ]
          )
        : _vm.type === "alert"
        ? _c(
            "svg",
            { staticClass: "h-1 w-1", attrs: { viewBox: "0 0 24 24" } },
            [
              _c("path", {
                staticClass: "fill-current",
                attrs: {
                  d:
                    "M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z"
                }
              })
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }